import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeVariant, BadgeSize } from '../../../types/ui.types';
import { cn } from '../../../utils/class-utils';

@Component({
    selector: 'jjames-badge',
    standalone: true,
    imports: [CommonModule],
    template: `
    <span [class]="badgeClasses">
      <ng-content></ng-content>
    </span>
  `,
    styles: []
})
export class JJamesBadgeComponent {
    @Input() variant: BadgeVariant = 'primary';
    @Input() size: BadgeSize = 'md';
    @Input() rounded = true;

    get badgeClasses(): string {
        const baseClasses = 'inline-flex items-center justify-center font-medium';

        const variantClasses = this.getVariantClasses();
        const sizeClasses = this.getSizeClasses();
        const roundedClasses = this.rounded ? 'rounded-full' : 'rounded-md';

        return cn(baseClasses, variantClasses, sizeClasses, roundedClasses);
    }

    private getVariantClasses(): string {
        const variants: Record<BadgeVariant, string> = {
            primary: 'bg-blue-100 text-blue-800',
            secondary: 'bg-gray-100 text-gray-800',
            success: 'bg-green-100 text-green-800',
            danger: 'bg-red-100 text-red-800',
            warning: 'bg-yellow-100 text-yellow-800',
            info: 'bg-cyan-100 text-cyan-800'
        };
        return variants[this.variant];
    }

    private getSizeClasses(): string {
        const sizes: Record<BadgeSize, string> = {
            sm: 'px-2 py-0.5 text-xs',
            md: 'px-2.5 py-0.5 text-sm',
            lg: 'px-3 py-1 text-sm'
        };
        return sizes[this.size];
    }
}